export enum Env {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  STAGING = 'staging',
}

export const getEnv = (key?: string): string | undefined => {
  try {
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined') {
      // @ts-ignore
      return import.meta.env[key];
    }

    if (key && typeof process !== 'undefined' && process.env) {
      return process.env[key];
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error accessing environment variable:', error);
  }

  return undefined; // fallback
};

export const getExecutionEnv = (): Env => getEnv('MODE') as Env;
